module.exports = __webpack_public_path__ + "static/media/truelark_icon.3c74f5a5.svg";